import { Row, Col } from "antd";
import { BadgeHelp, Phone, Smartphone, Mail } from "lucide-react";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";

export default function PFSection(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <Col {...responsiveInfo}>
      <DataGroup
        title={!verification?.NombreCompletoPF ? "Persona que firma el contrato" : `FIRMA: ${verification?.NombreCompletoPF}`}
        subtitle={
          verification?.TipoPersonaPF_T && verification?.NacionalidadPF_T
            ? "Persona " + verification?.TipoPersonaPF_T + ", " + verification?.NacionalidadPF_T
            : null
        }
        formName={"Persona que firma el contrato"}
        mainData={verification}
        setMainData={setVerification}
        verification={verification}
      >
        <DataItem
          icon={<BadgeHelp size={16} />}
          iconColor="brown"
          keyName={verification?.TipoDatoPF_T ? verification?.TipoDatoPF_T : "Tipo de identificación"}
          value={verification?.DatoPF_T}
          valueType="string"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Phone size={16} />}
          iconColor="#1890ff"
          keyName="Teléfono fijo"
          value={verification?.TelefonoFijoPF_T}
          valueType="phone"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Smartphone size={16} />}
          iconColor="indigo"
          keyName="Teléfono móvil"
          value={verification?.TelefonoMovilPF_T}
          valueType="phone"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Mail size={16} />}
          iconColor="#1890ff"
          keyName="Correo electrónico"
          value={verification?.CorreoElectronicoPF_T}
          valueType="email"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
      </DataGroup>
    </Col>
  );
}